import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function AppHeader({ title, back = false, right = null, onBack }) {
  const navigate = useNavigate();
  return (
    <div className="sg-topbar">
      <div className="sg-topbar-inner">
        {back && (
          <button
            className="sg-back-btn"
            data-testid="header-back"
            onClick={() => (onBack ? onBack() : navigate(-1))}
            aria-label="Back"
          >
            <ChevronLeft size={20} color="var(--ink)" />
          </button>
        )}
        <div className="sg-topbar-title">{title}</div>
        {right ? <div style={{ display: "flex", alignItems: "center", gap: 8 }}>{right}</div> : null}
      </div>
    </div>
  );
}
